import { post } from '@/helper/request';
import { useAppConfig } from '@/hooks/useAppConfig';
import useRestQuery from '@/hooks/useRestQuery';

const EMPTY_ARRAY: any[] = [];

export const UNSPLASH_RANDOM_URL = 'https://source.unsplash.com/random';

const useUnsplash = (variables: { query: string; page?: number; perPage?: number }) => {
  const {
    site: { disabledUnsplash },
  } = useAppConfig();
  const { isLoading, error, data } = useRestQuery(
    ['searchImages', variables.query, variables.page, variables.perPage],
    async () => {
      const res = await post('/external/unsplash/searchImages', variables);
      if (res?.success === false) {
        throw new Error(res);
      }
      return res;
    },
    { enabled: !disabledUnsplash },
  );

  return { fetching: isLoading, error, data: data ?? EMPTY_ARRAY };
};

export default useUnsplash;
